import {CheckIcon} from "@heroicons/react/20/solid";
import React from "react";
import Divider from "../generalComponents/divider";
import {ProductsData} from "../../data/productsData";
import {addCartItem} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";


export default function ModernPricingView() {

    const isSelected = false

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    return (
        <div className="flex justify-center bg-black py-20">
            <div className="w-full sm:w-11/12 md:w-3/4">


                <h2 className="" style={{color: "#FFF"}}>
                    Access all cashback starting from $59.00/mo. USD *
                </h2>

                <div className="mx-12">
                    <div
                        className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
                        {cardView(0)}
                        {cardView(1)}
                        {cardView(2)}

                    </div>
                </div>
                <div className="mt-4 text-base" style={{color: "#FFF"}}>
                    * Access is time-limited and may be withdrawn without prior notice.
                </div>
            </div>
        </div>
    )

    function cardView(index) {
        const productData = ProductsData[index];
        const advertisedFeatures = productData.advertisedFeatures

        return (
            <div
                className={classNames(
                    isSelected ? 'ring-2 ring-indigo-600' : 'ring-1 ring-gray-200',
                    'rounded-3xl p-8 pt-4 bg-white',
                )}
            >

                <div
                    className={classNames(
                        isSelected ? 'text-indigo-600' : 'text-gray-900',
                        'text-2xl font-semibold',
                    )}
                >
                    {productData.name}
                </div>
                <div
                    className='text-4xl my-2 font-semibold bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text'
                >
                    {productData.advertisedPriceMonth}
                </div>
                {/*<p className="text-base text-gray-600" style={{lineHeight: '1.5rem'}}>*/}
                {/*    Save{" "}*/}
                {/*    <div*/}
                {/*        className="font-semibold bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text">*/}
                {/*        $9/mo.*/}
                {/*    </div>*/}
                {/*    ** on your favorite content and iCloud+ storage.*/}
                {/*</p>*/}
                <p className="text-base text-gray-600" style={{lineHeight: '1.5rem'}}>
                    {
                        index === 0 &&
                        <p className="text-base text-gray-600" style={{lineHeight: '1.5rem'}}>
                            Get setup with the fastest growing store credit app on Shopify.
                        </p>
                    }
                    {
                        index === 1 &&
                        <p className="text-base text-gray-600" style={{lineHeight: '1.5rem'}}>
                            Start now and save{" "}
                            <div
                                className="font-semibold bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text">
                                $9/mo.
                            </div>
                            ** on your professional cashback tool.
                        </p>
                    }
                    {
                        index === 2 && "Premium access and support to all Pabloo products and features."
                    }
                </p>


                <div className="mt-4 mb-4" style={{
                    borderBottom: "1.25px solid #000",
                }}/>

                <a
                    href="/cart"
                    onClick={(e) => {
                        // Sets the cart data
                        let cartObject = {
                            productIndex: productData.id,
                            frequency: "month",
                            quantity: 1,
                        }
                        addCartItem(cartObject)

                        sendSlackMessageTracked(`Future client clicked on the pricing card for ${productData.advertisedPriceMonth}.`)
                    }}
                    className={"flex justify-center bg-black text-white shadow-xs hover:bg-indigo-500 rounded-full w-full text-base font-semibold"}
                    style={{
                        color: "#fff"
                    }}
                >
                    Buy plan
                </a>

                <div role="list" className="mt-4 mb-4 space-y-2 text-sm/6 text-gray-800">
                    {advertisedFeatures.map((feature) => (
                        <li key={feature} className="justify-left gap-x-3" style={{display: "flex", alignItems: "center"}}>
                            <div>
                                <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-indigo-600"/>
                            </div>
                            <div className="">
                                {feature}
                            </div>
                        </li>
                    ))}
                </div>

            </div>
        )
    }
}